import {
  AfterViewInit,
  Directive,
  ElementRef,
  NgZone,
  OnDestroy
} from '@angular/core';

const ARROWS =
  'li.ant-pagination-prev, li.ant-pagination-next, li.ant-pagination-jump-prev, li.ant-pagination-jump-next';

/**
 * ng-zorro draws the pager arrows as icon-only buttons and puts the Hebrew
 * name ("העמוד הקודם") on the list item's title, which screen readers do
 * not read for the button. This copies the title to the button.
 */
@Directive({
  // Every ng-zorro table and pager gets this, with nothing to add in templates.
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'nz-table, nz-pagination'
})
export class PagerLabelsDirective implements AfterViewInit, OnDestroy {
  private observer?: MutationObserver;

  constructor(
    private readonly el: ElementRef<HTMLElement>,
    private readonly zone: NgZone
  ) {}

  ngAfterViewInit(): void {
    if (typeof MutationObserver === 'undefined') return;
    this.zone.runOutsideAngular(() => {
      this.label();
      this.observer = new MutationObserver(() => this.label());
      this.observer.observe(this.el.nativeElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['title']
      });
    });
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  private label(): void {
    this.el.nativeElement
      .querySelectorAll<HTMLElement>(ARROWS)
      .forEach((li) => {
        const link = li.querySelector('.ant-pagination-item-link');
        const title = li.getAttribute('title');
        if (link && title && link.getAttribute('aria-label') !== title)
          link.setAttribute('aria-label', title);
      });
  }
}
